import React from 'react';

type MusicType = {

}

export const Music = (props: MusicType) => {
	return (
		<>
			<div>В стадии наполнения</div>
		</>
	);
};